import { getLanguages, service, sessionStore } from '../services';
import { ProductModelType, deflateModelVariables, isRequiredAndUnselected } from './modelHelperMethods';
import { remove } from './array';
import { AppStore } from '../store';

export const getOrderCode = product => {
  if ( !product ) {
    return '';
  }
  if ( product.orderCode ) {
    return product.orderCode;
  }
  if ( product.assignments ) {
    return product.assignments.reduce( ( cur, item ) => cur + item.value, '' );
  }
  return product.productCode;
};

export const getProductLink = (title,superCode='',configuredAcc=false) => {
  let culture = getLanguages().first().toLowerCase();
  const siteSettings = sessionStore.get( 'siteSettings' );
  if(configuredAcc && configuredAcc.length>0){
    return `${document.location.protocol}//new.abb.com/products/${ culture }/${superCode}`
  }
  if( siteSettings.changeLanguageCode && siteSettings.languageCodeMapping.hasOwnProperty( culture ) ) 
    culture = siteSettings.languageCodeMapping[culture];
  return `${ document.location.protocol }//new.abb.com/products/${ culture }/${ /[^+]+/.exec( title )[0] }`;
};


export const retrieveChildTemplate = templates => {
  return templates.map( template => {
  if ( template.productModelType === ProductModelType.SAP && template.configuration?.children?.length>0) {
    // find one of its children, but make sure that the assignments set are the ones available on the parent product
    return {
      ...template.configuration.children.first().childTemplate,
      assignments: [...template.assignments]
    };
  }
  // in all other cases, this is the template
  return template;
  });
}
// export const retrieveChildTemplate = template => {
//   if ( template.productModelType === ProductModelType.SAP ) {
//     // find one of its children, but make sure that the assignments set are the ones available on the parent product
//     return {
//       ...template.configuration.children.first().childTemplate,
//       assignments: [...template.assignments]
//     };
//   }
//   // in all other cases, this is the template
//   return template;
// }

const createConfigurationRequest = (template, newAssignments) => ({
  assignments: [],
  configuration: {
    configuration: template.materialKey,
    name: template.sourceLocation,
    plant: template.plant,
    usage: template.usage,
    existingAssignments: newAssignments?template.assignments.concat( newAssignments ):template.assignments
  }
});

const getProductWithConfiguration = ( product, configuration ) => {
  // work with the copy only
  product={...product,bom:product.bomItems }
  let configuredProduct = removeBomItemStatements( product );
  // add the configuration
  configuredProduct.configuration = {
    assignments: [],
    configuration: null,
    environment: {},
    materialKey: configuration.configuration|| configuration.materialKey,
    model: configuration.model,
    plant: configuration.plant,
    product: configuration.product,
    productModelType: ProductModelType.SAP,
    sourceLocation: configuration.name,
    usage: configuration.usage,
    validityInfo: configuration.validity
  };
  return configuredProduct;
}

const removeBomItemStatements = product => {
  const usableProduct = JSON.parse( JSON.stringify( product ) );
  // delete some unwanted things
  delete usableProduct.bomItems;
  delete usableProduct.allSatisfied;
  delete usableProduct.bomItemFields;
  delete usableProduct.hasBomItems;
  delete usableProduct.hasRequired;
  return usableProduct;
}

// this method will be called to fetch the template at the time of add to cart
const quickTemplateCheck = (product) =>{
  AppStore.dispatch({ type: 'dispatch-busy', action: 'filter-active' })
  return service( 'template' ).post( { name: product.name, filterGroups: product.filterSelectors } )
    .then( (response) => {
      AppStore.dispatch({ type: 'dispatch-complete', action: 'filter-active' })
      return response.data} )
      .then( template => {return  getAdditionalConfiguration(template,product)})
}
const getAdditionalConfiguration =async (template,product=[])=>{
  const frameSize=template[0].assignments?.find(a=>a.Key=='TAGLIA')?.Value
  const variables = deflateModelVariables( template[1].model );
  const frameVariable= variables.find(vari=>vari.properties?.isFrameSize==true)?.fullyQualifiedName;
  let key=''
  let value=''
  if(frameSize && template[1].productModelType==0){
     key=frameVariable, 
     value= frameSize+'.2'
  }
  const newAssignments=product.bomItems && product.bomItems.length>0? product.bomItems.map( i => ({    
    key: i.identifier.includes('NEUTRO_EXT')?"Accessories.MeasurementAndProtection.NEUTRO_EXT":i.identifier.split( '.' ).slice( 1 ).length>0?i.identifier.split( '.' ).slice( 1 ).join( '.' ):i.identifier,
    value: i.value.name ? i.value.name: i.value
  }) ).concat({key,value}):({key,value})
  return service( 'configure' ).post( createConfigurationRequest( 
    retrieveChildTemplate( template )[1], 
    newAssignments
  ) )
  .then( response => {return getConfiguration(template,response.data,product) })}

  const getConfiguration =async (template,configuration,product=[])=>{
    let existingAssignments=[];
    let configurationSensor={};
    product.bomItems && product.bomItems.forEach(bom=>{if(bom.identifier.includes('NEUTRO_EXT')){existingAssignments.push({"assignmentType":2,"key":"Accessories.MeasurementAndProtection.NEUTRO_EXT","value":bom.value})}})
    const additionalProducts = template.slice( 1 ).map( conf =>{if(conf.configuration?.children.lenght>0){return { ...conf.product, configuration: conf.configuration?.children.firstOrDefault()?.childTemplate }}else{configurationSensor={...conf,existingAssignments:existingAssignments};return{...conf.product, configuration: configurationSensor}}}) 
    const additionalProduct=[getProductWithConfiguration( additionalProducts[0], configuration )]
    return await service( 'configure' ).post( createConfigurationRequest( 
      retrieveChildTemplate( template )[0], 
      product.bomItems && product.bomItems.filter(bom=>{ return!bom.identifier.includes('NEUTRO_EXT')}).map( i => ({ 
        key: i.identifier.split( '.' ).slice( 1 ).length>0?i.identifier.split( '.' ).slice( 1 ).join( '.' ):i.identifier,
        value: i.value.name ? i.value.name: i.value
      }) )  
    ) ).then(response => {response.data
    
      const productList = {...product,additionalProducts:additionalProduct};
    return getProductWithConfiguration( productList, response.data ) })
  }

  
  const quickConfiguration = async ( product ) => {
    return service( 'template' ).post( { name: product.name, filterGroups: product.filterSelectors } )
      .then( response => response.data )
      .then( template => {return  getAdditionalConfiguration(template,product)})}

export const preProcessProducts = ( product, { warnMissingBomItems, warnNotAvailableInLocale }, currentPage ) => {
  const sitesettings = sessionStore.get( 'siteSettings' );
  if ('allSatisfied' in product) {
    return products => { 
      // suggested products not available yet, because the user needs to select more items
      // ask the user if they want to add the product to the cart anyhow
      // will resolve upon clicking Add, will reject when the user cancels
      if (!product.allSatisfied ) {
        if(!products[0].HidePopup){
          return new Promise( (resolve, reject) => warnMissingBomItems( products, resolve, reject ) );
        }
        if ( !hasBomItemAssignment( product ) ) {
          if(sitesettings.properties?.showPopup == undefined){
          return Promise.resolve( products.map( removeBomItemStatements ) );
          }
        }
        if(sitesettings.properties?.showPopup == undefined){
          return new Promise( (resolve, reject) => warnMissingBomItems( products, resolve, reject ) );
        }
      }
      return Promise.all( products.map( quickConfiguration ) ).catch( warnNotAvailableInLocale );
    }
  } 
  // for non configurable products no need of making the template call
  if(!product.isConfigurable && ( !product.materialName || product.materialName === product.name )){
    return null;
  }
  // for configurable product make the template call and check if mandatory accessories are there or not.
  if(currentPage && (currentPage==="productPage" || currentPage==="detailedSearchPage")){
    return products => new Promise((resolve, reject)=>{
      Promise.all(products.map( quickTemplateCheck )).then(res=>{
      
      // if no configuration available for the product just return the products to add in the cart
      if(!res.firstOrDefault()){
        resolve(products)
      }
      // if configuration is availble check for any mandatory accessories and reject the promise to show warning msg otherwise resolve and return the products
      else{
        // let firstTemplate = res.firstOrDefault().configuration.children.length==0?res.firstOrDefault().configuration:res.firstOrDefault().configuration.children.firstOrDefault();
        // //firstTemplate = res.firstOrDefault().firstOrDefault().configuration.children.firstOrDefault();
        //   const template = firstTemplate?.childTemplate;
        //   const variables = deflateModelVariables( template?.model );
        //   const tempRequiredUnselectedVariables = variables?.filter( isRequiredAndUnselected );
          // if(tempRequiredUnselectedVariables?.length>0){
          //   reject({dismissed:true, mandatoryAccessoryMissing:true, missingMandatoryAccessory:tempRequiredUnselectedVariables})
          // }
          // else{
            resolve(res)
          //}
      }
      })
    })
  }
  return null;
}

export const hasBomItemAssignment = ( { assignments, bomItemFields} ) => {
  const bomString = new RegExp( `${bomItemFields.join('|')}$`, 'ig' );
  return assignments.any( a => bomString.test( a.name ) && a.value !== 'Not applicable' );
};
